import React, { useState } from 'react';
import { BASE_URL } from 'shared/config';
import { useStateContext } from 'shared/contexts/ContextProvider';

const ClientEdit = () => {
  const [searchValue, setSearchValue] = useState('');
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    phone: '',
    birthday: '',
    gender: ''
  });
  const { token } = useStateContext();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const searchClient = async () => {
    setLoading(true);
    setError('');
    console.log('searching for client', BASE_URL);
    try {
      const response = await fetch(`${BASE_URL}/parties/admin-api/clients?search=${searchValue}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      
      if (data.status === 0 && data.response.rows.length > 0) {
        const clientData = data.response.rows[0];
        setClient(clientData);
        setFormData({
          first_name: clientData.first_name,
          last_name: clientData.last_name,
          phone: clientData.phone,
          birthday: clientData.birthday,
          gender: clientData.gender
        });
      } else {
        setError('Клиент не найден');
        setClient(null);
      }
    } catch (err) {
      setError('Ошибка при поиске клиента: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!client) return;
    
    setLoading(true);
    setError('');
    setSuccess('');
    
    try {
      const response = await fetch(`${BASE_URL}/parties/admin-api/clients/${client.id}/update-details/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });
      
      if (response.ok) {
        setSuccess('Клиент успешно обновлен');
      } else {
        const data = await response.json();
        const message = data.message || 'Ошибка при обновлении клиента';
        setError(message);
      }
    } catch (err) {
      setError('Ошибка при обновлении клиента');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='max-w-2xl mx-auto p-6 bg-white rounded-lg shadow'>
      <h2 className='text-2xl font-bold mb-6'>Редактировать клиента</h2>

      <div className='space-y-6'>
        {/* Search Section */}
        <div className='flex gap-2'>
          <input
            type='text'
            placeholder='Поиск по телефону или имени'
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            className='flex-1 px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
          />
          <button 
            onClick={searchClient}
            disabled={loading}
            className='px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-blue-300'
          >
            {loading ? 'Поиск...' : 'Найти'}
          </button>
        </div>

        {error && (
          <div className='p-4 bg-red-50 border border-red-200 text-red-700 rounded'>
            {error}
          </div>
        )}

        {success && (
          <div className='p-4 bg-green-50 border border-green-200 text-green-700 rounded'>
            {success}
          </div>
        )}

        {client && (
          <form onSubmit={handleSubmit} className='space-y-4'>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
              <div>
                <label className='block text-sm font-medium mb-1'>Имя</label>
                <input
                  type='text'
                  name='first_name'
                  value={formData.first_name}
                  onChange={handleInputChange}
                  required
                  className='w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
                />
              </div>
              
              <div>
                <label className='block text-sm font-medium mb-1'>Фамилия</label>
                <input
                  type='text'
                  name='last_name'
                  value={formData.last_name}
                  onChange={handleInputChange}
                  required
                  className='w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
                />
              </div>
            </div>

            <div>
              <label className='block text-sm font-medium mb-1'>Телефон</label>
              <input
                type='tel'
                name='phone'
                value={formData.phone}
                onChange={handleInputChange}
                required
                className='w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
              />
            </div>

            <div>
              <label className='block text-sm font-medium mb-1'>Дата рождения</label>
              <input
                type='date'
                name='birthday'
                value={formData.birthday}
                onChange={handleInputChange}
                className='w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
              />
            </div>

            <div>
              <label className='block text-sm font-medium mb-1'>Пол</label>
              <select
                name='gender'
                value={formData.gender}
                onChange={handleInputChange}
                className='w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
              >
                <option value=''>Выберите пол</option>
                <option value='male'>Мужской</option>
                <option value='female'>Женский</option>
              </select>
            </div>

            <div className='flex justify-end'>
              <button 
                type='submit' 
                disabled={loading}
                className='w-full md:w-auto px-6 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-blue-300'
              >
                {loading ? 'Обновление...' : 'Обновить'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ClientEdit;